import React, { useState, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import "./form-create.scss"
import MagazineService from "../../../shared/services/magazine"
import ModalCreateContents from "../../organisms/modal-create-contents/modal-create-contents"
import StandardModal from "../../../shared/components/modals/standard-modal/standard-modal"

import imgCrearContenido from "../../../assets/images/performance/CrearContenido.webp"
import imgCrearContenido_AR from "../../../assets/images/performance/imgCrearContenido_AR.webp"
import imgCrearContenido_Mb from "../../../assets/images/performance/CrearContenido_Mb.webp"

const FormCreate = props => {
  const { mobile, setModalActive } = props
  const resultQuery = useStaticQuery(
    graphql`
      query headerQuery2 {
        allContentfulNolMenuDeNavegacion(sort: { fields: titulo, order: ASC }) {
          nodes {
            node_locale
            enlaceSubMenu {
              enlaceContenidoSubmenu {
                titulo
                slug
                temaCreaContenido
              }
            }
            titulo
          }
        }
      }
    `
  )

  var navSubMenuTitles = resultQuery.allContentfulNolMenuDeNavegacion.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )[1].enlaceSubMenu
  const defaultactiveOption = { titulo: "Selecciona el tema", slug: "" }
  /* const defaultactiveOption = {
    slug: "bullying-por-loving",
    temaCreaContenido: true,
    titulo: "Bullying por Loving",
  } */

  let options = []
  navSubMenuTitles[0].enlaceContenidoSubmenu
    ? (options = navSubMenuTitles[0].enlaceContenidoSubmenu)
    : []
  options = options.filter(option => {
    return (
      option.slug !== "contenido-usuarias/" && option.temaCreaContenido !== null
    )
  })

  /* ---- Inputs ----- */
  const [nameInputValue, setnameInputValue] = useState("")
  const [titleInputValue, settitleInputValue] = useState("")
  const [firstImgValue, setfirstImgValue] = useState(null)
  const [secondImgValue, setsecondImgValue] = useState(null)
  const [thirdImgValue, setthirdImgValue] = useState(null)
  const [textAreaValue, settextAreaValue] = useState("")
  const [isAnonymous, setIsAnonymous] = useState("")
  /* ---- Inputs ----- */
  /* ---- Base64 values ----*/
  const [firstBase64Value, setfirstBase64Value] = useState(null)
  const [secondBase64Value, setsecondBase64Value] = useState(null)
  const [thirdBase64Value, setthirdBase64Value] = useState(null)
  /* ---- Base64 values ----*/

  /* ---- Button clear flags ----*/
  const [firstClearButton, setfirstClearButton] = useState(false)
  const [secondClearButton, setsecondClearButton] = useState(false)
  const [thirdClearButton, setthirdClearButton] = useState(false)
  /* ---- Button clear flags ----*/

  /* ---- Error flags ----- */
  const [nameInputError, setnameInputError] = useState(false)
  const [titleInputError, settitleInputError] = useState(false)
  const [imgsError, setimgsError] = useState(false)
  const [textareaError, settextareaError] = useState(false)
  const [textareaMinError, settextareaMinError] = useState(false)
  const [optionError, setoptionError] = useState(false)
  /* ---- Error flags ----- */

  const [disableButton, setdisableButton] = useState(false)

  const [count, setCount] = useState(0)
  const [activeOption, setactiveOption] = useState(defaultactiveOption)
  const [activeOptionTheme, setactiveOptionTheme] = useState("")
  const [activeSelect, setactiveSelect] = useState(false)

  const labelCreate =
    process.env.LOCALE === "es-AR"
      ? "Podés escribir acá el contenido o en otro lugar y luego pegarlo. La marca lo revisará y si es elegido podrás verlo en nuestro Magazín. Es posible que le realicemos ciertos ajustes para su publicación y luego de esto borraremos el archivo y las imágenes que nos enviaste."
      : process.env.LOCALE === "es-EC"
      ? "Cuéntanos tu historia y sé parte de este movimiento para que nuestras anécdotas con la menstruación no sean más historias de terror, sino historias normales que nos pasan a todas. Puedes redactarla en este espacio o si quieres puedes construirlo en otro lugar y luego pegarlo acá. Al enviarnos tu cuento participarás para ganar 1 de los 100 libros más canasta de productos que entregaremos a los mejores relatos."
      : "Escribe tu contenido acá o si quieres puedes construirlo en otro lugar y luego pegarlo acá. La marca lo revisará y si es elegido podrás verlo en nuestro Magazín. Es posible que le realicemos ciertos ajustes para su publicación y luego de esto borraremos el archivo y las imágenes que nos enviaste."

  useEffect(() => {
    let userInfo = JSON.parse(localStorage.getItem("USER_INFO"))
    setnameInputValue(userInfo.name + " " + userInfo.lastName)
  }, [])

  const handleSubmit = e => {
    e.preventDefault()

    var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken

    var config = {
      headers: {
        Authorization: tokenId,
      },
    }

    if (!haveErrors()) {
      setdisableButton(true)
      const fd = new FormData()
      /* if (isAnonymous === "anonimo") {
        fd.append("author", "Anónimo")
      } else {
        fd.append("author", nameInputValue)
      } */
      fd.append("author", nameInputValue)
      fd.append("article", textAreaValue)
      fd.append("firstImage", firstImgValue)
      fd.append("secondImage", secondImgValue)
      fd.append("thirdImage", thirdImgValue)
      fd.append("title ", titleInputValue)
      fd.append("country", process.env.COUNTRY_CODE)

      let valueOptionUpperCase = activeOption.titulo
      valueOptionUpperCase = valueOptionUpperCase
        .toUpperCase()
        .trim()
        .replace(/\s/g, "_")
      fd.append("theme", valueOptionUpperCase)

      MagazineService.postText(fd, config)
        .then(res => {
          if (res.status === 200) {
            setModalActive(
              <StandardModal
                title="Gracias, hemos recibido tu artículo"
                subtitle=""
                description="Nuestras expertas en contenido lo revisarán y si es elegido podrás verlo en nuestro Magazín. Es posible que ajustesmos detalles para potenciar tu contenido."
                noButton={true}
                click={() => {
                  resetStates()
                  setModalActive(null)
                }}
              />
            )
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    }
  }

  const handleAnonymous = event => {
    const { value } = event.target
    setIsAnonymous(value)
    console.log(value)
  }

  const setBase64 = (value, index) => {
    var reader
    if (index === 1) {
      reader = new FileReader()
      reader.onloadend = function() {
        setfirstBase64Value(reader.result)
      }
      reader.readAsDataURL(value)
    }
    if (index === 2) {
      reader = new FileReader()
      reader.onloadend = function() {
        setsecondBase64Value(reader.result)
      }
      reader.readAsDataURL(value)
    }
    if (index === 3) {
      reader = new FileReader()
      reader.onloadend = function() {
        setthirdBase64Value(reader.result)
      }
      reader.readAsDataURL(value)
    }
  }

  const clearInputFileValue = index => {
    if (index === 1) {
      setfirstImgValue(null)
      setfirstBase64Value(null)
    }

    if (index === 2) {
      setsecondImgValue(null)
      setsecondBase64Value(null)
    }

    if (index === 3) {
      setthirdImgValue(null)
      setthirdBase64Value(null)
    }
  }

  const getFormat = name => {
    return name.split(".")[name.split(".").length - 1].toLowerCase()
  }

  const resetStates = () => {
    setnameInputValue("")
    settitleInputValue("")
    setfirstImgValue(null)
    setsecondImgValue(null)
    setthirdImgValue(null)
    settextAreaValue("")
    setdisableButton(false)
    setactiveSelect(false)
    setoptionError(false)
    setactiveOption(defaultactiveOption)
  }

  const haveErrors = () => {
    if (nameInputValue === "" || nameInputValue === " ") {
      setnameInputError(true)
    } else {
      setnameInputError(false)
    }

    if (titleInputValue === "" || titleInputValue === " ") {
      settitleInputError(true)
    } else {
      settitleInputError(false)
    }

    if (firstImgValue !== null) {
      if (
        getFormat(firstImgValue.name) !== "jpg" &&
        getFormat(firstImgValue.name) !== "jpeg" &&
        getFormat(firstImgValue.name) !== "png"
      ) {
        setimgsError(true)
      } else {
        setimgsError(false)
      }

      if (firstImgValue.size > 5242880) {
        setimgsError(true)
      } else {
        setimgsError(false)
      }
    }

    if (secondImgValue !== null) {
      if (
        getFormat(secondImgValue.name) !== "jpg" &&
        getFormat(secondImgValue.name) !== "jpeg" &&
        getFormat(secondImgValue.name) !== "png"
      ) {
        setimgsError(true)
      } else {
        setimgsError(false)
      }

      if (secondImgValue.size > 5242880) {
        setimgsError(true)
      } else {
        setimgsError(false)
      }
    }

    if (thirdImgValue !== null) {
      if (
        getFormat(thirdImgValue.name) !== "jpg" &&
        getFormat(thirdImgValue.name) !== "jpeg" &&
        getFormat(thirdImgValue.name) !== "png"
      ) {
        setimgsError(true)
      } else {
        setimgsError(false)
      }

      if (thirdImgValue.size > 5242880) {
        setimgsError(true)
      } else {
        setimgsError(false)
      }
    }

    if (textAreaValue === "" || textAreaValue === " ") {
      settextareaError(true)
    } else {
      settextareaError(false)
    }

    if (textAreaValue && textAreaValue.length < 1500) {
      settextareaMinError(true)
    } else {
      settextareaMinError(false)
    }

    if (activeOption.titulo === "Selecciona el tema") {
      setoptionError(true)
    } else {
      setoptionError(false)
    }

    return (
      nameInputValue === "" ||
      nameInputValue === " " ||
      titleInputValue === "" ||
      titleInputValue === " " ||
      (firstImgValue !== null
        ? getFormat(firstImgValue.name) !== "jpg" &&
          getFormat(firstImgValue.name) !== "jpeg" &&
          getFormat(firstImgValue.name) !== "png"
        : false) ||
      (secondImgValue !== null
        ? getFormat(secondImgValue.name) !== "jpg" &&
          getFormat(secondImgValue.name) !== "jpeg" &&
          getFormat(secondImgValue.name) !== "png"
        : false) ||
      (thirdImgValue !== null
        ? getFormat(thirdImgValue.name) !== "jpg" &&
          getFormat(thirdImgValue.name) !== "jpeg" &&
          getFormat(thirdImgValue.name) !== "png"
        : false) ||
      (firstImgValue !== null ? firstImgValue.size > 5242880 : false) ||
      (secondImgValue !== null ? secondImgValue.size > 5242880 : false) ||
      (thirdImgValue !== null ? thirdImgValue.size > 5242880 : false) ||
      textAreaValue === "" ||
      textAreaValue === " " ||
      (textAreaValue && textAreaValue.length < 1500) ||
      activeOption.titulo === "Selecciona el tema"
    )
  }

  return (
    // =================================================
    // Esto se muestra mientras se cambia la seccion
    <>
      {mobile ? (
        <img
          src={imgCrearContenido_Mb}
          style={{ width: "100%" }}
          alt="banner crear contenido"
        />
      ) : (
        <img
          src={
            ["es-AR", "es-UY", "es-PY"].includes(process.env.LOCALE)
              ? imgCrearContenido_AR
              : imgCrearContenido
          }
          style={{ width: "100%" }}
          alt="banner crear contenido"
        />
      )}
    </>
    // =================================================

    // <form className="f-form-create" autoComplete="off">
    //   <div className="f-top-form">
    //     <label className="f-title-form">
    //       <>
    //         {process.env.LOCALE === "es-AR" ? "Compartinos" : "Compártenos"} tu
    //         contenido aquí.{" "}
    //       </>
    //     </label>
    //     {!mobile && <p className="f-form-description">{labelCreate}</p>}
    //   </div>
    //   <div className="f-inputs-container">
    //     <div className="f-group">
    //       <div className="f-input-group f-input-name ">
    //         <label className="f-input-label">TU NOMBRE</label>
    //         <input
    //           value={nameInputValue}
    //           placeholder="Juliana González"
    //           type="text"
    //           className={
    //             "f-input-question f-input-name " +
    //             (nameInputError ? "input-error" : "")
    //           }
    //           name="f-name-input"
    //           onChange={e => {
    //             setnameInputValue(e.target.value.replace(/ {2}/g, " "))
    //           }}
    //         />
    //         {nameInputError && (
    //           <label className="f-label-error">*Este campo es requerido</label>
    //         )}
    //       </div>
    //       <div className="f-input-group">
    //         <label className="f-input-label">EL NOMBRE DE TU ARTÍCULO</label>
    //         <input
    //           value={titleInputValue}
    //           placeholder="Título"
    //           maxLength="60"
    //           type="text"
    //           className={
    //             "f-input-question " + (titleInputError ? "input-error" : "")
    //           }
    //           name="f-title-input"
    //           onChange={e => {
    //             settitleInputValue(e.target.value.replace(/ {2}/g, " "))
    //           }}
    //         />
    //         {titleInputError && (
    //           <label className="f-label-error">*Este campo es requerido</label>
    //         )}
    //       </div>
    //     </div>

    //     <div className="f-group">
    //       <div className="f-input-group">
    //         <label className="f-input-label">EL TEMA DE TU ARTÍCULO</label>
    //         <div
    //           className={
    //             "f-input-question f-fake-select " +
    //             (optionError ? "input-error" : "")
    //           }
    //           onClick={() => setactiveSelect(true)}
    //         >
    //           <label className="f-label-inside">{activeOption.titulo}</label>
    //           <span className="f-icon icon-down" />
    //           {optionError && (
    //             <label className="f-label-error option-label">
    //               *Elije una opción
    //             </label>
    //           )}

    //           {activeSelect && (
    //             <ul className="f-collapse-menu">
    //               {options.map((option, index) => {
    //                 return (
    //                   <li
    //                     className="f-item-option"
    //                     key={index}
    //                     onClick={e => {
    //                       e.stopPropagation()
    //                       setactiveSelect(false)
    //                       setactiveOption(option)
    //                       setdisableButton(false)
    //                     }}
    //                   >
    //                     {option.titulo}
    //                   </li>
    //                 )
    //               })}
    //             </ul>
    //           )}
    //         </div>
    //       </div>

    //       <div className="f-input-group">
    //         <label className="f-input-label">
    //           SUBE UNA IMAGEN PARA TU ARTÍCULO
    //         </label>

    //         <div className="f-boxes-container">
    //           <div
    //             className="f-box-file-container"
    //             onMouseEnter={() => setfirstClearButton(true)}
    //             onMouseLeave={() => setfirstClearButton(false)}
    //           >
    //             {firstBase64Value === null ? (
    //               <>
    //                 <input
    //                   className="f-input-file-box"
    //                   type="file"
    //                   name="f-first-image"
    //                   onChange={e => {
    //                     setfirstImgValue(e.target.files[0])
    //                     setBase64(e.target.files[0], 1)
    //                   }}
    //                 />
    //                 <span className="f-icon icon2-camara" />
    //               </>
    //             ) : (
    //               <>
    //                 <div className="f-prev-img-container">
    //                   <img
    //                     className="f-prev-img"
    //                     alt="Previo de primera imagen"
    //                     src={firstBase64Value}
    //                   />
    //                 </div>
    //                 {mobile ? (
    //                   <div
    //                     className="f-button-close-container"
    //                     onClick={() => clearInputFileValue(1)}
    //                   >
    //                     <span className="icon2-close" />
    //                   </div>
    //                 ) : firstClearButton ? (
    //                   <div
    //                     className="f-button-close-container"
    //                     onClick={() => clearInputFileValue(1)}
    //                   >
    //                     <span className="icon2-close" />
    //                   </div>
    //                 ) : null}
    //               </>
    //             )}
    //           </div>
    //           <div
    //             className="f-box-file-container"
    //             onMouseEnter={() => setsecondClearButton(true)}
    //             onMouseLeave={() => setsecondClearButton(false)}
    //           >
    //             {secondBase64Value === null ? (
    //               <>
    //                 <input
    //                   className="f-input-file-box"
    //                   type="file"
    //                   name="f-second-image"
    //                   onChange={e => {
    //                     setsecondImgValue(e.target.files[0])
    //                     setBase64(e.target.files[0], 2)
    //                   }}
    //                 />
    //                 <span className="f-icon icon2-camara" />
    //               </>
    //             ) : (
    //               <>
    //                 <div className="f-prev-img-container">
    //                   <img
    //                     className="f-prev-img"
    //                     alt="Previo de segunda imagen"
    //                     src={secondBase64Value}
    //                   />
    //                 </div>
    //                 {mobile ? (
    //                   <div
    //                     className="f-button-close-container"
    //                     onClick={() => clearInputFileValue(2)}
    //                   >
    //                     <span className="icon2-close" />
    //                   </div>
    //                 ) : secondClearButton ? (
    //                   <div
    //                     className="f-button-close-container"
    //                     onClick={() => clearInputFileValue(2)}
    //                   >
    //                     <span className="icon2-close" />
    //                   </div>
    //                 ) : null}
    //               </>
    //             )}
    //           </div>
    //           <div
    //             className="f-box-file-container"
    //             onMouseEnter={() => setthirdClearButton(true)}
    //             onMouseLeave={() => setthirdClearButton(false)}
    //           >
    //             {thirdBase64Value === null ? (
    //               <>
    //                 <input
    //                   className="f-input-file-box"
    //                   type="file"
    //                   name="f-third-image"
    //                   onChange={e => {
    //                     setthirdImgValue(e.target.files[0])
    //                     setBase64(e.target.files[0], 3)
    //                   }}
    //                 />
    //                 <span className="f-icon icon2-camara" />
    //               </>
    //             ) : (
    //               <>
    //                 <div className="f-prev-img-container">
    //                   <img
    //                     className="f-prev-img"
    //                     alt="Previo de tercera imagen"
    //                     src={thirdBase64Value}
    //                   />
    //                 </div>
    //                 {mobile ? (
    //                   <div
    //                     className="f-button-close-container"
    //                     onClick={() => clearInputFileValue(3)}
    //                   >
    //                     <span className="icon2-close" />
    //                   </div>
    //                 ) : thirdClearButton ? (
    //                   <div
    //                     className="f-button-close-container"
    //                     onClick={() => clearInputFileValue(3)}
    //                   >
    //                     <span className="icon2-close" />
    //                   </div>
    //                 ) : null}
    //               </>
    //             )}
    //           </div>
    //           <label
    //             className={
    //               "f-advise-message " + (imgsError ? "advise-error" : "")
    //             }
    //           >
    //             *El formato debe ser .jpg o .png y no superar 5mb de tamaño
    //           </label>
    //         </div>
    //       </div>
    //     </div>

    //     <div className="f-input-group complete">
    //       <label className="f-input-label">ESCRIBE TU ARTÍCULO</label>
    //       {process.env.LOCALE === "es-AR" ||
    //       process.env.LOCALE === "es-PY" ||
    //       process.env.LOCALE === "es-UY" ? (
    //         <p className="f-input-description">
    //           Elegí un tema que te apasione y escribe sobre este. Podes
    //           inspirarte en tu hobbie favorito o algo de lo que sepas muchísimo.
    //         </p>
    //       ) : (
    //         <p className="f-input-description">
    //           Elige un tema que te apasione y escribe sobre este. Puedes
    //           inspirarte en tu hobbie favorito o algo de lo que sepas muchísimo.
    //         </p>
    //       )}
    //       <textarea
    //         type="text"
    //         className={
    //           "f-textarea-question " +
    //           (textareaError || textareaMinError ? "input-error" : "")
    //         }
    //         name="f-article-textarea"
    //         placeholder="Escribe tu artículo..."
    //         minLength="1500"
    //         maxLength="3000"
    //         value={textAreaValue}
    //         onChange={e => {
    //           if (
    //             !/^[ a-zA-Z0-9#°áéíóúÁÉÍÓÚäëïöüÄËÏÖÜñÑ,.;:()¿?¡!_-]+$/.test(
    //               e.target.value
    //             )
    //           ) {
    //             return false
    //           } else {
    //             settextAreaValue(e.target.value.replace(/ {2}/g, " "))
    //             setCount(e.target.value.length)
    //           }
    //         }}
    //       ></textarea>
    //       {textareaError && (
    //         <label className="f-label-error">*Este campo es requerido</label>
    //       )}
    //       {textareaMinError && (
    //         <label className="f-label-error">
    //           *Este campo debe ser minimo 1500 caracteres
    //         </label>
    //       )}
    //       <span className="textarea__count">{count} / 3000</span>
    //     </div>

    //     {/* <div className="f-input-group anonymous">
    //       <label className="f-input-label">
    //         ¿QUIERES QUE TU HISTORIA SEA PUBLICADA ANÓNIMA?
    //       </label>
    //       <div className="options">
    //         <label className="f-radio-container">
    //           Sí
    //           <input
    //             type="radio"
    //             name="anonymous"
    //             value="anonimo"
    //             onClick={handleAnonymous}
    //             className="checkbox"
    //           />
    //           <span className="checkmark"></span>
    //         </label>
    //         <label className="f-radio-container">
    //           No
    //           <input
    //             type="radio"
    //             name="anonymous"
    //             value="noanonimo"
    //             onClick={handleAnonymous}
    //             defaultChecked={true}
    //             className="checkbox"
    //           />
    //           <span className="checkmark"></span>
    //         </label>
    //       </div>
    //     </div> */}

    //     <div className="f-button-position">
    //       <div
    //         className={
    //           "f-button-container " + (disableButton ? "disable-button" : "")
    //         }
    //       >
    //         <button className="f-submit-modal" onClick={e => handleSubmit(e)}>
    //           Enviar
    //         </button>
    //       </div>
    //     </div>
    //   </div>
    // </form>
  )
}

export default FormCreate
